import React from 'react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Landmark, Users, ShieldCheck, Satellite, Layers, Bell, Map as MapIcon, ScanSearch, ClipboardList, FileText, Building2, Settings, Activity } from 'lucide-react';

const modules = [
  { Icon: Building2, title: 'Multi-tenant organisations', desc: 'Isolated data, users, assets, alerts and audit logs per customer.' },
  { Icon: Users, title: 'Role-based access', desc: 'Six roles from Super Admin to Field User; every action authorised.' },
  { Icon: Landmark, title: 'Asset registry', desc: 'Hydropower-specific fields — dam type, FRL, MWL, catchment, generating units.' },
  { Icon: MapIcon, title: 'Map onboarding', desc: 'Draw boundaries, define 7 zone types on ESRI satellite basemap.' },
  { Icon: Satellite, title: 'Observation ingestion', desc: 'Configurable data-source framework — optical, thermal, weather.' },
  { Icon: Layers, title: 'Baseline management', desc: 'Versioned approved baselines with lock and history.' },
  { Icon: ScanSearch, title: 'CV + LLM detection', desc: 'Pixel-level change masks + vision LLM classification & risk.' },
  { Icon: Bell, title: 'Alerts & escalation', desc: 'Threshold-driven alerts, notifications and escalation rules.' },
  { Icon: ClipboardList, title: 'Incident management', desc: 'Assignment, comments, attachments, field verification, closure.' },
  { Icon: FileText, title: 'PDF reports', desc: 'Alert, incident and asset monitoring reports with evidence frames.' },
  { Icon: ShieldCheck, title: 'Audit trail', desc: 'Immutable log for every mutation — who, what, when, before/after.' },
  { Icon: Activity, title: 'Operational health', desc: 'Real-time source, ingestion, processing and model health.' },
];

export default function FeaturesPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16">
      <Badge variant="secondary">Product</Badge>
      <h1 className="font-display text-4xl font-semibold mt-3">Every capability an infrastructure operator needs.</h1>
      <p className="mt-3 text-muted-foreground max-w-2xl">Aakash Drishti covers the complete satellite intelligence workflow — from ingesting an observation to closing a validated incident — in a single audit-ready platform.</p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-10">
        {modules.map(({Icon, title, desc}) => (
          <Card key={title} className="p-5 border-border hover:border-primary/40 transition-colors">
            <Icon size={22} className="text-primary" />
            <div className="mt-3 font-semibold">{title}</div>
            <div className="mt-1 text-sm text-muted-foreground">{desc}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
